// src/utils/periodos.js
/**
 * Genera una lista de períodos desde enero 2024 hasta el mes actual
 * NOTA: En el futuro, esta función debería obtener los períodos desde una tabla de períodos abiertos
 * @returns {Array} - Lista de períodos en formato {value: "YYYYMM", label: "Mes YYYY"}
 */
export const generarPeriodos = () => {
    const opciones = [];
    const hoy = new Date();
    
    // Configuración fija: empezar desde enero 2024
    const startYear = 2024;
    const startMonth = 0; // enero (0-indexed)
    
    const currentYear = hoy.getFullYear();
    const currentMonth = hoy.getMonth(); // 0-11
    
    // Calcular el número total de meses desde enero 2024 hasta el mes actual
    const totalMonths = (currentYear - startYear) * 12 + (currentMonth - startMonth) + 1;
    
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    // Generar cada período desde enero 2024 hasta el mes actual
    for (let i = 0; i < totalMonths; i++) {
      // Calcular año y mes para cada período
      const targetMonth = (startMonth + i) % 12;
      const targetYear = startYear + Math.floor((startMonth + i) / 12);
      
      // Formato para el valor (YYYYMM)
      const monthStr = (targetMonth + 1).toString().padStart(2, '0');
      const periodoValue = `${targetYear}${monthStr}`;
      
      // Etiqueta legible (Mes Año)
      const periodoLabel = `${nombresMeses[targetMonth]} ${targetYear}`;
      
      opciones.push({ value: periodoValue, label: periodoLabel });
    }
    
    // Ordenar de más reciente a más antiguo
    return opciones.sort((a, b) => b.value.localeCompare(a.value));
  };